import React, { lazy } from 'react';
interface ProtectedImageProps {
  src: string;
  alt: string;
  className?: string;
  watermarkText?: string;
  /** Extra classes for the outer wrapper */
  wrapperClassName?: string;
  /** If true, renders as a background-cover fill (for hero-style usage) */
  fill?: boolean;
  /** Optional lazy loading */
  loading?: 'lazy' | 'eager';
}
export function ProtectedImage({
  src,
  alt,
  className = '',
  watermarkText = '© Alejandro Noriega',
  wrapperClassName = '',
  fill = false,
  loading = 'eager'
}: ProtectedImageProps) {
  // Append low-res query param to simulate preview resolution
  const previewSrc = src.includes('unsplash.com') ? src.replace(/w=\d+/, 'w=1200').replace(/q=\d+/, 'q=60') : src;
  return <div className={`protected-image-wrapper relative overflow-hidden ${wrapperClassName}`} style={{
    WebkitUserSelect: 'none',
    userSelect: 'none',
    WebkitTouchCallout: 'none'
  } as React.CSSProperties} data-id="element-242">
      {/* The actual image */}
      <img src={previewSrc} alt={alt} loading={loading} draggable={false} onContextMenu={e => e.preventDefault()} onDragStart={e => e.preventDefault()} className={`protected-image transition-all duration-500 ${className}`} style={{
      WebkitUserDrag: 'none',
      WebkitUserSelect: 'none',
      userSelect: 'none',
      pointerEvents: 'none'
    } as React.CSSProperties} data-id="element-243" />

      {/* Transparent overlay to block direct image interaction */}
      <div className="absolute inset-0 z-10" onContextMenu={e => e.preventDefault()} onDragStart={e => e.preventDefault()} style={{
      WebkitTouchCallout: 'none'
    } as React.CSSProperties} aria-hidden="true" data-id="element-244" />

      {/* Subtle Corner Watermark */}
      <div className="absolute bottom-4 right-4 z-20 pointer-events-none opacity-15" aria-hidden="true" data-id="element-245">
        <span className="text-white font-sans text-[10px] tracking-[0.2em] uppercase whitespace-nowrap select-none drop-shadow-md" style={{
        userSelect: 'none'
      }} data-id="element-246">
          {watermarkText}
        </span>
      </div>
    </div>;
}